/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
  /* SAVE_ASSET,
    SET_ADDRESS,
    GET_ASSET_FROM_RETS,
    SUCCESS_GET_ASSET_FROM_RETS,
    FAILURE_GET_ASSET_FROM_RETS,
    SAVE_RENT_TO_ASSET,
    SAVE_RENT_TO_ASSET_SUCCESS,
    SAVE_RENT_TO_ASSET_FAILURE,
    TOGGLE_EDIT_ASSET_MODAL,

    UPDATE_ASSET_DETAILS,
    UPDATE_ASSET_DETAILS_SUCCESS,
    UPDATE_ASSET_DETAILS_FAILURE,

    UPDATE_ASSET_DETAILS_STATE,

    TOGGLE_UPDATE_ASSET_INVEST_MODAL,
    UPDATE_ASSET_INVEST_DETAILS,
    UPDATE_ASSET_INVEST_DETAILS_SUCCESS,
    UPDATE_ASSET_INVEST_DETAILS_FAILURE,
    UPDATE_ASSET_INVEST_DETAILS_STATE,
    RENT_DETAIL_SUCCESS,
    RENT_DETAIL_FAILURE,
    DELETE_RENT_FROM_ASSET_SUCCESS,
    DELETE_RENT_FROM_ASSET_FAILURE,
    SAVE_INSURANCE_TO_ASSET_SUCCESS,
    SAVE_INSURANCE_TO_ASSET_FAILURE,

    LOOKUP_ASSET, */
  SUCCESS_SAVE_ASSET,
  FAILURE_SAVE_ASSET,
  ASSET_DETAIL_SUCCESS,
  ASSET_DETAIL_FAILURE,
  LOOKUP_ASSET,
  LOOKUP_ASSET_SUCCESS,
  LOOKUP_ASSET_FAILURE,
  BULK_ADD_ASSET,
  BULK_ADD_ASSET_SUCCESS,
  BULK_ADD_ASSET_FAILURE,
  LOOKUP_PARCEL,
  LOOKUP_PARCEL_SUCCESS,
  LOOKUP_PARCEL_FAILURE,
  RESET_ADD_ASSET,
  ADD_ASSET_AND_FINANCIALS,
  ADD_ASSET_AND_FINANCIALS_SUCCESS,
  ADD_ASSET_AND_FINANCIALS_FAILURE,
  ADD_ENTITY,
  ADD_ENTITY_SUCCESS,
  ADD_ENTITY_FAILURE,
  GET_ENTITIES,
  GET_ENTITIES_SUCCESS,
  GET_ENTITIES_FAILURE
} from "../actions/asset/assetActionTypes";

import {
  setLoadingState,
  setSuccessResponse,
  setErrorResponse
} from "./reducerUtils";

const initialState = {
  bulkAddAsset: {
    data: [],
    state: "INIT",
    error: null
  },
  parcelLookup: {
    data: [],
    state: "INIT",
    error: null
  },
  assetLookup: {
    data: [],
    state: "INIT",
    error: null
  },
  addAssetAndFinancials: {
    data: [],
    state: "INIT",
    error: null
  },
  entities: {
    data: [],
    state: "INIT",
    error: null
  }
};

export default function(state = initialState, action) {
  switch (action.type) {
    // case SET_ADDRESS:
    //     return {
    //         selectedAddress: action.payload,
    //     }

    // case SUCCESS_GET_ASSET_FROM_RETS:

    //     return {
    //         ...state,
    //         fetching: false,
    //         result: action.payload.data
    //     }
    // case FAILURE_GET_ASSET_FROM_RETS:
    //     return {
    //         ...state,
    //         fetching: false,
    //         success: false,
    //         message: action.err.message
    //     }
    // case SAVE_ASSET:
    //     return {
    //         ...state,
    //         saving: true,
    //     }
    case SUCCESS_SAVE_ASSET:
      return {
        // ...state,
        // saving: false,
        // success: true,
        isSavingAssetSuccess: true,
        slug: action.payload.data.slug
      };
    case FAILURE_SAVE_ASSET:
      return {
        // ...state,
        // saving: false,
        // success: false,
        isSavingAssetSuccess: false,
        error: action.err.message
      };
    case ASSET_DETAIL_SUCCESS:
      return {
        // loading: false,
        assetDetailSuccess: true,
        data: action.payload.data
      };
    case ASSET_DETAIL_FAILURE:
      return {
        // loading: false,
        assetDetailSuccess: false,
        error: action.err.message
      };

    case LOOKUP_ASSET:
      return setLoadingState(state, "assetLookup");

    case LOOKUP_ASSET_SUCCESS:
      return setSuccessResponse(state, action, "assetLookup");

    case LOOKUP_ASSET_FAILURE:
      return setErrorResponse(state, action.err, "assetLookup");

    case BULK_ADD_ASSET:
      return setLoadingState(state, "bulkAddAsset");

    case BULK_ADD_ASSET_SUCCESS:
      return setSuccessResponse(state, action, "bulkAddAsset");

    case BULK_ADD_ASSET_FAILURE:
      return setErrorResponse(state, action.errResp, "bulkAddAsset");

    case LOOKUP_PARCEL:
      return setLoadingState(state, "parcelLookup");

    case LOOKUP_PARCEL_SUCCESS:
      return setSuccessResponse(state, action, "parcelLookup");

    case LOOKUP_PARCEL_FAILURE:
      return setErrorResponse(state, action.errResp, "parcelLookup");

    case RESET_ADD_ASSET:
      return setLoadingState(state, "addAssetAndFinancials");
    case ADD_ASSET_AND_FINANCIALS:
      return setLoadingState(state, "addAssetAndFinancials");
    case ADD_ASSET_AND_FINANCIALS_SUCCESS:
      return setSuccessResponse(state, action, "addAssetAndFinancials");
    case ADD_ASSET_AND_FINANCIALS_FAILURE:
      return setErrorResponse(state, action.errResp, "addAssetAndFinancials");

    case ADD_ENTITY:
      return setLoadingState(state, "entities", "ADD");
    case ADD_ENTITY_SUCCESS:
      return setSuccessResponse(state, action, "entities", "ADD");
    case ADD_ENTITY_FAILURE:
      return setErrorResponse(state, action.errResp, "entities", "ADD");
    case GET_ENTITIES:
      return setLoadingState(state, "entities", "GET");
    case GET_ENTITIES_SUCCESS:
      return setSuccessResponse(state, action, "entities", "GET");
    case GET_ENTITIES_FAILURE:
      return setErrorResponse(state, action.errResp, "entities", "GET");

    default:
      return state;
    //success on fetching rental detail
    // case RENT_DETAIL_SUCCESS:
    //     return {
    //         ...state,
    //         loading: false,
    //         fetchDetailSuccess: true,
    //         fetchDetail: action.payload.data,
    //     }
    // case RENT_DETAIL_FAILURE:
    //     return {
    //         ...state,
    //         loading: false,
    //         fetchDetailSuccess: false,
    //         fetchDetail: false,
    //     }
    //save rent to asset
    // case SAVE_RENT_TO_ASSET:
    //     return {
    //         ...state,
    //         saving: true,
    //     }
    // case SAVE_RENT_TO_ASSET_SUCCESS:
    //     return {
    //         ...state,
    //         saving: false,
    //         rentSaveSuccess: true,
    //         slug: action.payload.data.slug
    //     }
    // case SAVE_RENT_TO_ASSET_FAILURE:
    //     return {
    //         ...state,
    //         saving: false,
    //         rentSaveSuccess: false,
    //         message: action.payload.message
    //     }
    // case DELETE_RENT_FROM_ASSET_SUCCESS:
    //     return {
    //         ...state,
    //         rentDeleteSuccess: true,
    //     }
    // case DELETE_RENT_FROM_ASSET_FAILURE:
    //     return {
    //         ...state,
    //         rentDeleteSuccess: false,
    //     }
    //toggle for Asset Detailing page
    // case TOGGLE_EDIT_ASSET_MODAL:
    //     return {
    //         ...state, isEditAssetModalOpen: !state.isEditAssetModalOpen
    //     }

    // case TOGGLE_INSURANCE_MODAL:
    //     return {
    //         ...state,
    //         isInsuranceModalOpen: !state.isInsuranceModalOpen
    //     }
    // case INSURANCE_ADDITION_SUCCESS:
    //     return {
    //         ...state,
    //         isInsuranceModalOpen: !state.isInsuranceModalOpen
    //     }

    // case UPDATE_ASSET_DETAILS:
    //     return {
    //         ...state,
    //         loading: true,
    //     }
    // case UPDATE_ASSET_DETAILS_SUCCESS:

    //     return {
    //         ...state,
    //         isEditAssetModalOpen: false,
    //         loading: false,
    //         success: true,
    //     }

    // case UPDATE_ASSET_DETAILS_FAILURE:
    //     return {
    //         ...state,
    //         // isEditAssetModalOpen:state.isEditAssetModalOpen,
    //         loading: false,
    //         success: false,
    //     }

    // case UPDATE_ASSET_DETAILS_STATE:
    //     return {
    //         ...state,
    //         data: {
    //             ...state.data,
    //             lotSizeSquareFeet: action.payload.areaSquareFeet,
    //             baths: action.payload.baths,
    //             beds: action.payload.beds,
    //             country: action.payload.country,
    //             lotSizeAcres: action.payload.lot_size,
    //             units: action.payload.units,
    //             yearBuilt: action.payload.yearBuilt,
    //         }
    //     }

    // case TOGGLE_UPDATE_ASSET_INVEST_MODAL:
    //     return {
    //         ...state,
    //         loading: false,
    //         success: false,
    //         isEditAssetInvestmentModalOpen: !state.isEditAssetInvestmentModalOpen,
    //     }

    // case UPDATE_ASSET_INVEST_DETAILS:
    //     return {
    //         ...state,
    //         loading: true,

    //     };
    // case UPDATE_ASSET_INVEST_DETAILS_SUCCESS:
    //     return {
    //         ...state,
    //         isEditAssetInvestmentModalOpen: false,
    //         loading: false,
    //         success: true,
    //     };
    // case UPDATE_ASSET_INVEST_DETAILS_FAILURE:
    //     return {
    //         ...state,
    //         loading: false,
    //         success: false,
    //     };
    // case UPDATE_ASSET_INVEST_DETAILS_STATE:
    //     return {
    //         ...state,
    //         data: {
    //             ...state.data,
    //             purchaseDate: action.payload.purchaseDate,
    //             purchasePrice: action.payload.purchasePrice,
    //             market_value: action.payload.market_value,
    //             rental_value: action.payload.rental_value,
    //         }
    //     }
    // case SAVE_INSURANCE_TO_ASSET_SUCCESS:
    //     return {
    //         ...state,
    //         saveInsuranceSuccess: true,
    //         data: {
    //             ...state.data,
    //             insuranceDetail: action.payload.insuranceDetail
    //         }
    //     };
    // case SAVE_INSURANCE_TO_ASSET_FAILURE:
    //     return {
    //         ...state,
    //         saveInsuranceSuccess: true
    //     };
    // case SET_TAX_DUE_DATE_SUCCESS:
    //     return {
    //         ...state,
    //         setTaxDueDateToAsset: true
    //     };
    // case SET_TAX_DUE_DATE_FAILURE:
    //     return {
    //         ...state,
    //         setTaxDueDateToAsset: false
    //     };
    // case LOOKUP_ASSET:
    //     return {
    //         ...state,
    //         requested: true,
    //         fetching: true,
    //         saving: false,
    //     }
  }
}
